import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthInstitution } from "../pages/AuthInstitution";

export function AuthInstitutionRouter() {
  return (
    <Routes>
      {/* Ruta con parámetro dinámico :assistantId */}
      <Route path="/" element={<AuthInstitution />} />
    </Routes>
  );
}
